import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { DatepickerCalendarLocaleType, DatepickerSelectedDateType, DatepickerShowDateType } from "@website/ui/datepicker/datepicker.types";
import { addMonth, createShowDatesArray, getShowDatesInitial, getToday, subtractMonth } from "@website/ui/datepicker/datepicker.utils";
import { useEffectJustChanges } from "@website/utils/use-effect-just-changes/useEffectJustChanges";
import { useState } from "react";
export const INITIAL_SHOW_DATES_NUMBER = 2;
export const useShowDate = (calendarLocale, scrollToTop, value, view) => {
  const $ = _c(41);
  const {
    isDesktop
  } = useViewPort();
  const t0 = value[0]?.dateTime;
  let t1;
  if ($[0] !== calendarLocale || $[1] !== t0) {
    t1 = getShowDatesInitial(t0, INITIAL_SHOW_DATES_NUMBER, calendarLocale);
    $[0] = calendarLocale;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [showDates, setShowDates] = useState(t1);
  let t2;
  if ($[3] !== calendarLocale || $[4] !== showDates || $[5] !== value || $[6] !== view) {
    t2 = () => {
      const slicedShowDates = view === "mobile" ? showDates.slice(0, 1) : showDates;
      if (value?.some(index => !slicedShowDates.some(index_ => index_.year === index.year && index_.month === index.month))) {
        setShowDates(getShowDatesInitial(value[0].dateTime, INITIAL_SHOW_DATES_NUMBER, calendarLocale));
      }
    };
    $[3] = calendarLocale;
    $[4] = showDates;
    $[5] = value;
    $[6] = view;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== value) {
    t3 = [value];
    $[8] = value;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useEffectJustChanges(t2, t3);
  let t4;
  if ($[10] !== calendarLocale || $[11] !== showDates.length) {
    t4 = () => {
      setShowDates(createShowDatesArray(calendarLocale, showDates.length));
    };
    $[10] = calendarLocale;
    $[11] = showDates.length;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== calendarLocale) {
    t5 = [calendarLocale];
    $[13] = calendarLocale;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  useEffectJustChanges(t4, t5);
  let t6;
  if ($[15] !== calendarLocale || $[16] !== showDates.length) {
    t6 = () => {
      setShowDates(createShowDatesArray(calendarLocale, showDates.length + 1));
    };
    $[15] = calendarLocale;
    $[16] = showDates.length;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const increaseShowDatesNumber = t6;
  let t7;
  if ($[18] !== calendarLocale) {
    t7 = getToday(calendarLocale);
    $[18] = calendarLocale;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const today = t7;
  let t8;
  if ($[20] !== showDates) {
    t8 = showDates.at(-1)?.year;
    $[20] = showDates;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== showDates) {
    t9 = showDates.at(-1)?.month;
    $[22] = showDates;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const nextMonthDisabled = (Number(t8) - today.year) * 12 + (Number(t9) - today.month) >= 12;
  const previousMonthDisabled = (showDates[0].year - today.year) * 12 + (showDates[0].month - today.month) <= 0;
  let t10;
  if ($[24] !== nextMonthDisabled || $[25] !== showDates) {
    t10 = () => {
      if (!nextMonthDisabled) {
        const newShowDates = showDates.map(_temp);
        setShowDates(newShowDates);
      }
    };
    $[24] = nextMonthDisabled;
    $[25] = showDates;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const onNextMonthClick = t10;
  let t11;
  if ($[27] !== previousMonthDisabled || $[28] !== showDates) {
    t11 = () => {
      if (!previousMonthDisabled) {
        const newShowDates_0 = showDates.map(_temp2);
        setShowDates(newShowDates_0);
      }
    };
    $[27] = previousMonthDisabled;
    $[28] = showDates;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const onPreviousMonthClick = t11;
  let t12;
  if ($[30] !== calendarLocale || $[31] !== isDesktop) {
    t12 = () => {
      if (isDesktop) {
        setShowDates(createShowDatesArray(calendarLocale, INITIAL_SHOW_DATES_NUMBER));
      } else {
        const element = document.querySelector("#main-calendar");
        element?.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    };
    $[30] = calendarLocale;
    $[31] = isDesktop;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  const onShowTodayClick = t12;
  let t13;
  if ($[33] !== increaseShowDatesNumber || $[34] !== nextMonthDisabled || $[35] !== onNextMonthClick || $[36] !== onPreviousMonthClick || $[37] !== onShowTodayClick || $[38] !== previousMonthDisabled || $[39] !== showDates) {
    t13 = {
      onNextMonthClick,
      onPreviousMonthClick,
      onShowTodayClick,
      showDates,
      increaseShowDatesNumber,
      nextMonthDisabled,
      previousMonthDisabled,
      setShowDates
    };
    $[33] = increaseShowDatesNumber;
    $[34] = nextMonthDisabled;
    $[35] = onNextMonthClick;
    $[36] = onPreviousMonthClick;
    $[37] = onShowTodayClick;
    $[38] = previousMonthDisabled;
    $[39] = showDates;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  return t13;
};
function _temp(item) {
  const newDate = addMonth(item.year, item.month, 1);
  return {
    year: newDate.year,
    month: newDate.month
  };
}
function _temp2(item_0) {
  const newDate_0 = subtractMonth(item_0.year, item_0.month, 1);
  return {
    year: newDate_0.year,
    month: newDate_0.month
  };
}